import * as actionTypes from '../actions/actionTypes';
import { moduleContext, sideContext } from 'context'
import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash'

const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};

const initialState = {
    sessionId: uuidv4(),
    modalElement: null,
    secModalElement: null,
    modalID: null,
    secModalID: null,
    inputID: null,
    inputID2: null,
    window: null,
    body: null,
    toast_ids: [],
    toasts: [],

    // Sidebar
    side: sideContext.TYPES.CLOSED,
    // side: sideContext.TYPES.OPENED,

    // File uploads,
    url: null,
    error: null,

    // Access module
    showAccess: false,
    access: 'CALENDAR',
    // access: moduleContext.MODULES.HISTORY,
    accessProps: {range: 'day'},
};


const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.SET_SIDE:
            return updateObject(state, {side: action.side})
        case actionTypes.SET_ACCESS:
            return updateObject(state, {showAccess: action.showAccess, access: action.access, accessProps: action.accessProps})
        case actionTypes.SET_MODAL:
            return updateObject(state, {modalElement: action.element, modalID: action.id}) // Removed setting inputID
        case actionTypes.SET_SEC_MODAL:
            return updateObject(state, {secModalElement: action.element, secModalID: action.id})
        case actionTypes.SET_INPUT:
            return updateObject(state, {inputID: action.inputID, inputID2: action.inputID2})
        case actionTypes.SET_WINDOW:
            return updateObject(state, {window: action.window, body: action.body})
        case actionTypes.SET_TOASTS:
            return updateObject(state, { toasts: _.union(state.toasts, action.toasts)})
        case actionTypes.UPLOAD_FILE:
            return updateObject(state, {url: action.url})
        case actionTypes.UPLOAD_ERROR:
            return updateObject(state, {error: action.error})
        case actionTypes.UPLOAD_RESET:
            return updateObject(state, {url: null, error: null})
        default:
            return updateObject(state)
    }
};

export default reducer;
